// Mock data for NY Pest & Exterminating

export const companyInfo = {
  name: "NY Pest & Exterminating",
  phone: "(646) 209-9955",
  phoneRaw: "6462099955",
  email: "reclaimexterminating@gmail.com",
  tagline: "Pest control you can trust, with an eco-friendly touch!",
  usp: "100% Eco-Friendly & Pet-Safe Solutions",
  uspSubtitle: "Green Shield Approach - Safe for Your Family, Tough on Pests"
};

export const services = [
  {
    id: "pest-inspection",
    title: "Pest Inspection",
    description: "Thorough property inspection to identify pest problems and entry points.",
    icon: "Search",
    image: "https://customer-assets.emergentagent.com/job_pestfree-ny/artifacts/j3ye2m67_bigstock-Young-Male-Pest-Control-Worker-284040370-1200x800.jpg",
    features: ["Complete property assessment", "Pest identification", "Entry point detection", "Treatment recommendations"]
  },
  {
    id: "rats-mice",
    title: "Rats & Mice",
    description: "Rodent Extermination NYC: Ultimate Guide to Expert Mice & Rat Removal\n\nWelcome to the definitive resource for professional rodent extermination in New York City. If you're searching for \"rodent control NYC,\" \"emergency rat exterminator,\" or \"mice removal near me,\" you've found your solution. Our licensed, eco-conscious exterminators specialize in eliminating infestations in apartments, brownstones, restaurants, and commercial buildings across all five boroughs and Nassau County, Suffolk County, Westchester County.\n\nEmergency Rodent Problem? We Provide 24/7 Fast Response in NYC\n\n• Same-Day Service Available | Free Inspections & Quotes | Satisfaction Guaranteed\n\nWhy NYC Properties Are Vulnerable to Rodents\n\nNew York City's dense infrastructure, aging plumbing, and constant activity create ideal conditions for mice and rats. Common entry points include:\n\n• Subway & Sewer Adjacency: Rats exploit underground networks.\n• Construction Gaps: Around pipes, vents, and foundation cracks.\n• Multi-Unit Buildings: Rodents travel between apartments via walls and utility lines.\n\nOur Comprehensive 5-Step Rodent Eradication System\n\n1. Inspection: We inspect areas to identify species, nest locations, and entry points.\n2. Custom Exclusion Sealing: We permanently seal entryways with rodent-proof materials, going beyond basic caulking.\n3. Strategic Elimination: Utilizing tamper-resistant bait stations, snap traps, and live traps placed in high-activity zones—always prioritizing child and pet safety.\n4. Sanitation & Decontamination: We clean urine/fecal trails and apply treatment to eliminate pheromone trails that attract new rodents.\n5. Monitoring & Prevention: Installing monitoring systems and providing a detailed prevention plan for property managers and residents.\n\nSigns You Need Professional Rodent Extermination in NYC\n\n• Scratching noises in walls or ceilings, especially at night\n• Rodent droppings rice-sized for mice, olive pit-sized for rats\n• Gnaw marks on food packaging, wires, or baseboards\n• Unusual pet behavior or nests made from shredded materials\n• Urgent: Sightings during daylight indicate a severe infestation\n\nOur NYC Service Areas: Local Exterminators Near You\n\nWe provide rodent control in Manhattan, Brooklyn, Queens, The Bronx, and Staten Island, Nassau County, Suffolk County, Westchester County including high-need zones near parks, waterways, and historic districts.\n\nTargeted Solutions for NYC's Unique Challenges\n\n• Apartment & Co-op Rodent Control: Discreet, effective treatments with minimal disruption. We coordinate with building management for building-wide solutions.\n\n• Restaurant & Commercial Kitchen Compliance: We help you pass DOH inspections with pest control logs and exclusion services.\n\n• Brownstone & Historic Home Preservation: We use techniques that protect architectural integrity while eliminating rodents.\n\n• Construction Site Prevention: Pre-treatment and exclusion plans to keep sites rodent-free.\n\nFAQs: Rodent Extermination in New York City\n\n• \"How much does rat extermination cost in NYC?\" Ans: Pricing is based on infestation severity and property size. We offer transparent, upfront quotes and honest pricing.\n\n• \"Are your treatments safe for children and pets?\" Ans: Yes. We use EPA-registered products and secure, targeted methods.\n\n• \"Do you offer warranties?\" \nAns: We provide industry-leading guarantees with follow-up visits to ensure complete eradication.\n\n• \"How quickly can you get here?\" \nAns: We offer same-day and next-day emergency services for active infestations.\n\nHealth Risks of New York Rodents: Act Now\n\nNew York rats and mice carry pathogens like leptospirosis, salmonella, and can trigger asthma/allergies. DIY methods often fail, allowing infestations to grow. Professional exclusion is the only permanent solution.\n\nCall Now for a Free Rodent Inspection & Quote\n\nNY Pest & Exterminating– NYC's Most Trusted Rodent Exterminators\nServing Manhattan, Brooklyn, Queens, The Bronx, Staten Island, Nassau County, Suffolk County, Westchester County.\n24/7 Emergency Hotline: (646) 209-9955",
    icon: "MousePointer",
    image: "https://images.unsplash.com/photo-1624065934925-1acc4791d798?w=800&q=80",
    features: ["Emergency 24/7 Response", "5-Step Eradication System", "Child & Pet Safe Methods", "Free Inspection & Quote", "Same-Day Service Available", "Building-Wide Solutions", "DOH Compliance Support", "Industry-Leading Guarantee"]
  },
  {
    id: "bed-bugs",
    title: "Bed Bugs",
    description: "Effective bed bug removal using heat treatment and eco-safe insecticides.",
    icon: "AlertTriangle",
    image: "https://customer-assets.emergentagent.com/job_pestfree-ny/artifacts/dp5t1x5s_unnamed.png",
    features: ["Heat treatment", "Steam cleaning", "Follow-up inspections"]
  },
  {
    id: "cockroaches",
    title: "Cockroaches",
    description: "Complete cockroach extermination for residential and commercial properties.",
    icon: "Bug",
    image: "https://images.unsplash.com/photo-1727198634627-645ef5356455?w=800&q=80",
    features: ["German & American roaches", "Gel baiting", "Crack & crevice treatment", "Sanitation recommendations"]
  },
  {
    id: "ants",
    title: "Ants",
    description: "Effective ant control targeting colonies and entry points.",
    icon: "Layers",
    image: "https://images.unsplash.com/photo-1588470045344-4393b295297c?w=800&q=80",
    features: ["Colony elimination", "Perimeter treatment", "Baiting systems", "Prevention strategies"]
  },
  {
    id: "fleas-mites",
    title: "Fleas or Mites",
    description: "Fast relief from fleas and mites with pet-safe treatments.",
    icon: "CircleDot",
    image: "https://images.pexels.com/photos/40795/spider-macro-zebra-spider-insect-40795.jpeg?w=800&q=80",
    features: ["Pet-safe treatments", "Indoor & outdoor treatment", "Follow-up service", "Prevention advice"]
  },
  {
    id: "hornets-wasps",
    title: "Hornets & Wasps",
    description: "Safe removal of hornets, wasps, and their nests.",
    icon: "Triangle",
    image: "https://images.unsplash.com/photo-1584709261141-f32daef6aa9f?w=800&q=80",
    features: ["Nest removal", "Same-day service", "Safe elimination", "Prevention measures"]
  },
  {
    id: "spiders",
    title: "Spiders",
    description: "Spider control and web removal for homes and businesses.",
    icon: "Network",
    image: "https://images.unsplash.com/photo-1598356918644-7a5af992f40c?w=800&q=80",
    features: ["Web removal", "Perimeter treatment", "Interior treatment", "Ongoing prevention"]
  },
  {
    id: "flies",
    title: "Flies",
    description: "Comprehensive fly control for residential and commercial properties.",
    icon: "Wind",
    image: "https://images.unsplash.com/photo-1596296455028-bb216ae02ff7?w=800&q=80",
    features: ["Source elimination", "Sanitation guidance", "Treatment application", "Prevention planning"]
  },
  {
    id: "bees",
    title: "Bees",
    description: "Humane bee removal and relocation services.",
    icon: "Hexagon",
    image: "https://images.unsplash.com/photo-1601039727490-458d3e7f2799?w=800&q=80",
    features: ["Live bee relocation", "Hive removal", "Same-day service", "Bee-friendly approach"]
  },
  {
    id: "bird-proofing",
    title: "Bird Proofing",
    description: "Professional bird deterrent installation and exclusion services.",
    icon: "Bird",
    image: "https://images.unsplash.com/photo-1539664030485-a936c7d29c6e?w=800&q=80",
    features: ["Netting installation", "Spike systems", "Humane deterrents", "Cleanup services"]
  },
  {
    id: "mosquitoes",
    title: "Mosquitoes",
    description: "Seasonal mosquito control for yards and outdoor spaces.",
    icon: "Droplet",
    image: "https://images.unsplash.com/photo-1707943768453-7850f916ebde?w=800&q=80",
    features: ["Barrier spray treatment", "Breeding site elimination", "Monthly service", "Special event treatment"]
  },
  {
    id: "termites",
    title: "Termites",
    description: "Comprehensive termite inspection and treatment to protect your property.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1612960891902-b525d250aa89?w=800&q=80",
    features: ["Free inspection", "Liquid treatments", "Baiting systems", "Damage repair coordination"]
  },
  {
    id: "wildlife-removal",
    title: "Wildlife or Animal Removal",
    description: "Humane wildlife removal and exclusion for raccoons, squirrels, and more.",
    icon: "Squirrel",
    image: "https://images.pexels.com/photos/51340/rat-pets-eat-51340.jpeg?w=800&q=80",
    features: ["Humane trapping", "Safe relocation", "Entry point repair", "Attic cleanup"]
  },
  {
    id: "airbnb-pest-control",
    title: "Airbnb Pest Control",
    description: "Fast turnaround pest management for vacation rentals and short-term properties.",
    icon: "Building",
    image: "https://images.pexels.com/photos/7166557/pexels-photo-7166557.jpeg?w=800&q=80",
    features: ["Between-guest treatments", "Emergency 24/7 service", "Discreet service", "Guest-safe products"]
  }
];

export const serviceAreas = [
  {
    id: "brooklyn",
    name: "Brooklyn",
    description: "Serving all Brooklyn neighborhoods with rapid response pest control services."
  },
  {
    id: "queens",
    name: "Queens",
    description: "Professional pest extermination throughout Queens County."
  },
  {
    id: "manhattan",
    name: "Manhattan",
    description: "Manhattan pest control experts available 24/7 for emergencies."
  },
  {
    id: "bronx",
    name: "The Bronx",
    description: "Fast, reliable pest control services across The Bronx."
  },
  {
    id: "staten-island",
    name: "Staten Island",
    description: "Comprehensive pest management for Staten Island homes and businesses."
  },
  {
    id: "nassau-county",
    name: "Nassau County",
    description: "Expert pest control services throughout Nassau County, Long Island."
  },
  {
    id: "suffolk-county",
    name: "Suffolk County",
    description: "Suffolk County's trusted pest extermination professionals."
  },
  {
    id: "westchester-county",
    name: "Westchester County",
    description: "Serving Westchester County with eco-friendly pest solutions."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Martinez",
    location: "Brooklyn, NY",
    rating: 5,
    text: "After dealing with mice for months, NY Pest came out the same day and solved the problem completely. Their eco-friendly approach was perfect for our family with young kids.",
    service: "Rodent Control"
  },
  {
    id: 2,
    name: "David Chen",
    location: "Manhattan, NY",
    rating: 5,
    text: "Professional, punctual, and effective. They eliminated our bed bug problem with heat treatment and followed up to ensure they were gone for good. Highly recommend!",
    service: "Bed Bug Removal"
  },
  {
    id: 3,
    name: "Restaurant Owner - Queens",
    location: "Queens, NY",
    rating: 5,
    text: "We've been using NY Pest for our restaurant for over a year. They're discreet, reliable, and help us maintain perfect health inspection scores. Worth every penny.",
    service: "Commercial Pest Control"
  },
  {
    id: 4,
    name: "Jennifer Wilson",
    location: "Westchester County, NY",
    rating: 5,
    text: "Excellent termite inspection and treatment. They explained everything clearly and their guarantee gives us peace of mind. Our home is now protected!",
    service: "Termite Treatment"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "How to Identify Early Signs of Termite Damage in NYC Homes",
    excerpt: "Learn the warning signs of termite infestations before they cause serious structural damage to your New York property.",
    category: "Termites",
    date: "2025-03-15",
    readTime: "5 min read",
    image: "/blog/termites.jpg"
  },
  {
    id: 2,
    title: "Winterizing Your NYC Home Against Rodents",
    excerpt: "As temperatures drop, rodents seek warmth indoors. Here's how to protect your home this winter.",
    category: "Rodents",
    date: "2025-03-10",
    readTime: "4 min read",
    image: "/blog/rodents.jpg"
  },
  {
    id: 3,
    title: "Are Eco-Friendly Pest Control Methods Really Effective?",
    excerpt: "Debunking myths about green pest control and why it's the best choice for NYC families.",
    category: "Eco-Friendly",
    date: "2025-03-05",
    readTime: "6 min read",
    image: "/blog/eco-friendly.jpg"
  },
  {
    id: 4,
    title: "Understanding IPM: Integrated Pest Management for Restaurants",
    excerpt: "A comprehensive guide to IPM strategies that keep commercial kitchens pest-free and compliant.",
    category: "Commercial",
    date: "2025-03-01",
    readTime: "7 min read",
    image: "/blog/commercial.jpg"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Are your treatments safe for children and pets?",
    answer: "Absolutely! Our Green Shield Approach uses EPA-approved, eco-friendly products that are completely safe for children and pets. We prioritize non-toxic and plant-based solutions whenever possible."
  },
  {
    id: 2,
    question: "How quickly can you respond to an emergency?",
    answer: "We offer same-day service for urgent pest problems. Simply call us at (646) 209-9955, and we'll dispatch a technician to your location as quickly as possible, often within 2-4 hours."
  },
  {
    id: 3,
    question: "Do you offer a guarantee?",
    answer: "Yes! We stand behind our work with our Satisfaction Guaranteed promise. If pests return between scheduled treatments, we'll come back at no additional charge until the problem is resolved."
  },
  {
    id: 4,
    question: "What areas do you serve?",
    answer: "We proudly serve all five NYC boroughs (Manhattan, Brooklyn, Queens, The Bronx, Staten Island) plus Nassau County, Suffolk County, and Westchester County."
  },
  {
    id: 5,
    question: "How much does pest control cost?",
    answer: "Every situation is unique. We offer free, no-obligation quotes after assessing your specific pest problem. Contact us today for a customized estimate."
  }
];